import type {
  FacilityUnlockAccessEventsListApiData,
  FacilityUnlockAccessEventsListApiResponses,
  FacilityUnlockLockAccessCreateApiData,
  FacilityUnlockLockAccessCreateApiResponses,
  FacilityUnlockLockAccessDeleteApiData,
  FacilityUnlockLockAccessDeleteApiResponses,
  FacilityUnlockLockAccessesListApiData,
  FacilityUnlockLockAccessesListApiResponses,
  FacilityUnlockLockAccessEventsListApiData,
  FacilityUnlockLockAccessEventsListApiResponses,
  FacilityUnlockLockCloseApiData,
  FacilityUnlockLockCloseApiResponses,
  FacilityUnlockLockCreateApiData,
  FacilityUnlockLockCreateApiResponses,
  FacilityUnlockLockDeleteApiData,
  FacilityUnlockLockDeleteApiResponses,
  FacilityUnlockLockOpenApiData,
  FacilityUnlockLockOpenApiResponses,
  FacilityUnlockLocksListApiData,
  FacilityUnlockLocksListApiResponses,
  FacilityUnlockLockWebhookDeleteApiData,
  FacilityUnlockLockWebhookDeleteApiResponses,
  FacilityUnlockLockWebhookRegisterApiData,
  FacilityUnlockLockWebhookRegisterApiResponses,
  FacilityUnlockLockWebhooksListApiData,
  FacilityUnlockLockWebhooksListApiResponses,
  UnlockLocksListApiData,
  UnlockLocksListApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getUnlockUrls = {
  getFacilityUnlockLocks: dataEndpoint<FacilityUnlockLocksListApiData, FacilityUnlockLocksListApiResponses>({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/`)
  }),
  postFacilityUnlockLock: responseEndpoint<FacilityUnlockLockCreateApiData, FacilityUnlockLockCreateApiResponses>({
    getUrl: ({ storageFacilityId }) => apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/`),
    getBody: ({ storageFacilityId: _, ...body }) => body
  }),
  deleteFacilityUnlockLock: dataEndpoint<FacilityUnlockLockDeleteApiData, FacilityUnlockLockDeleteApiResponses>({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/`)
  }),
  getFacilityUnlockAccessEvents: dataEndpoint<
    FacilityUnlockAccessEventsListApiData,
    FacilityUnlockAccessEventsListApiResponses
  >({
    getUrl: ({ storageFacilityId, ...queryParams }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-access-events/`, queryParams)
  }),
  getFacilityUnlockLockAccessEvents: dataEndpoint<
    FacilityUnlockLockAccessEventsListApiData,
    FacilityUnlockLockAccessEventsListApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId, ...queryParams }) =>
      apiUrl(
        `storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/access-events/`,
        queryParams
      )
  }),
  getFacilityUnlockLockAccesses: dataEndpoint<
    FacilityUnlockLockAccessesListApiData,
    FacilityUnlockLockAccessesListApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/accesses/`)
  }),
  postFacilityUnlockLockAccess: responseEndpoint<
    FacilityUnlockLockAccessCreateApiData,
    FacilityUnlockLockAccessCreateApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/accesses/`),
    getBody: ({ storageFacilityId: _, storageFacilityLockId: __, ...body }) => body
  }),
  deleteFacilityUnlockLockAccess: dataEndpoint<
    FacilityUnlockLockAccessDeleteApiData,
    FacilityUnlockLockAccessDeleteApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId, accessId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/accesses/${accessId}/`)
  }),
  getFacilityUnlockLockWebhooks: dataEndpoint<
    FacilityUnlockLockWebhooksListApiData,
    FacilityUnlockLockWebhooksListApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/webhooks/`)
  }),
  postFacilityUnlockLockWebhook: responseEndpoint<
    FacilityUnlockLockWebhookRegisterApiData,
    FacilityUnlockLockWebhookRegisterApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/webhooks/`)
  }),
  deleteFacilityUnlockLockWebhook: dataEndpoint<
    FacilityUnlockLockWebhookDeleteApiData,
    FacilityUnlockLockWebhookDeleteApiResponses
  >({
    getUrl: ({ storageFacilityId, storageFacilityLockId, webhookId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/webhooks/${webhookId}/`)
  }),
  postFacilityUnlockLockOpen: responseEndpoint<FacilityUnlockLockOpenApiData, FacilityUnlockLockOpenApiResponses>({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/open/`),
    getBody: ({ storageFacilityId: _, storageFacilityLockId: __, ...body }) => body
  }),
  postFacilityUnlockLockClose: responseEndpoint<FacilityUnlockLockCloseApiData, FacilityUnlockLockCloseApiResponses>({
    getUrl: ({ storageFacilityId, storageFacilityLockId }) =>
      apiUrl(`storage-facilities/${storageFacilityId}/unlock-locks/${storageFacilityLockId}/close/`),
    getBody: ({ storageFacilityId: _, storageFacilityLockId: __, ...body }) => body
  }),
  /** External Unloc locks available to attach to a facility. */
  getUnlockLocks: dataEndpoint<UnlockLocksListApiData, UnlockLocksListApiResponses>({
    getUrl: (queryParams) => apiUrl('unlock/locks/', queryParams)
  })
};
